import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import styles from './ProductCard.module.css';

const formatPrice = (n) => `₦${Number(n).toLocaleString()}`;

export default function ProductCard({ product }) {
  const { add, remove, updateQty, items } = useCart();
  const cartItem = items.find(i => i.id === product.id);
  const qty = cartItem?.qty || 0;

  const discount = product.originalPrice
    ? Math.round((1 - product.price / product.originalPrice) * 100)
    : null;

  const handleAdd = (e) => { e.preventDefault(); add(product); };
  const handleIncrease = (e) => { e.preventDefault(); add(product); };
  const handleDecrease = (e) => {
    e.preventDefault();
    if (qty === 1) remove(product.id);
    else updateQty(product.id, qty - 1);
  };

  return (
    <Link to={`/product/${product.id}`} className={styles.card}>
      <div className={styles.imgWrap}>
        <img src={product.image} alt={product.name} className={styles.img} loading="lazy" />
        {product.badge && (
          <span className={`${styles.badge} ${styles[`badge_${product.badge.toLowerCase().replace(/ /g, '_')}`]}`}>
            {product.badge}
          </span>
        )}
        {discount && <span className={styles.discount}>-{discount}%</span>}
      </div>

      <div className={styles.body}>
        <div className={styles.rating}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="var(--accent)" stroke="none">
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
          </svg>
          <span>{product.rating}</span>
          <span className={styles.reviews}>({Number(product.reviews).toLocaleString()})</span>
        </div>

        <h3 className={styles.name}>{product.name}</h3>

        <div className={styles.pricing}>
          <span className={styles.price}>{formatPrice(product.price)}</span>
          {product.originalPrice && (
            <span className={styles.original}>{formatPrice(product.originalPrice)}</span>
          )}
        </div>

        {qty === 0 ? (
          <button className={styles.addBtn} onClick={handleAdd}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
            Add to cart
          </button>
        ) : (
          <div className={styles.qtyRow} onClick={e => e.preventDefault()}>
            <button className={styles.qtyBtn} onClick={handleDecrease}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                <line x1="5" y1="12" x2="19" y2="12"/>
              </svg>
            </button>
            <span className={styles.qtyNum}>{qty}</span>
            <button className={styles.qtyBtn} onClick={handleIncrease}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
              </svg>
            </button>
          </div>
        )}
      </div>
    </Link>
  );
}
